"use strict";

var _interopRequireDefault = require("D:/a2/Code_New/Web/node_modules/@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es6.function.name");

var _download = require("@/api/download");

var _Pagination = _interopRequireDefault(require("@/components/Pagination"));

var _moment = _interopRequireDefault(require("moment"));

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = {
  components: {
    Pagination: _Pagination.default
  },
  data: function data() {
    return {
      isShowDrawer: false,
      isShowVerifyCode: false,
      verifyForm: {
        id: '',
        verifyCode: '' //提取码

      },
      listLoading: false,
      list: [],
      total: 0,
      listQuery: {
        page: 1,
        limit: 20,
        sort: "id",
        order: "desc"
      },
      verifyRules: {
        verifyCode: [{
          required: true,
          message: "提取码不能为空",
          trigger: "blur"
        }]
      }
    };
  },
  methods: {
    getList: function getList() {
      var _this = this;

      (0, _download.downloadList)(this.listQuery).then(function (res) {
        _this.list = res.data.data.list;
        _this.total = res.data.data.total;
      });
    },
    confirmVerifyCode: function confirmVerifyCode() {
      var _this2 = this;

      this.$refs["verifyForm"].validate(function (valid) {
        if (valid) {
          (0, _download.download)(_this2.verifyForm).then(function (res) {
            _this2.isShowVerifyCode = false;
            _this2.isShowDrawer = false;

            _this2.$notify.success({
              title: "提醒",
              message: "文件已发送到您的邮箱，请注意查收；如果是大文件请稍等片刻"
            });
          }).catch(function (err) {
            _this2.$notify.error({
              title: "提醒",
              message: err.data.errmsg
            });
          });
        }
      });
    },
    handleDownload: function handleDownload(row) {
      this.verifyForm = {
        id: row.id,
        verifyCode: ''
      };
      this.isShowVerifyCode = true;
      return;
      var status = row.status;
      row.status = 4; //防止多次点击

      (0, _download.download)({
        id: row.id
      }).then(function (res) {
        row.status = 4; //已下载

        var fileName = row.name + ".zip";
        var link = document.createElement("a");
        link.target = '_blank';
        console.info('https://' + window.location.host + '/download/' + fileName);
        link.href = 'https://' + window.location.host + '/download/' + fileName;
        link.download = fileName;
        link.click(); //移除a标签

        link.remove();
      }).catch(function (err) {
        row.status = status;
      });
    }
  }
};
exports.default = _default;